export default "__VITE_PUBLIC_ASSET__15f2d8c1__"